import Gleap from "gleap";
import { readonly, ref } from "vue";

// Gleap rejects with `undefined` when bursts of identical identify calls get rate limited (429).
let lastIdentifiedSessionKey: string | null = null;
const unreadCount = ref(0);

export const useGleap = () => {
  const route = useRoute();

  const isHiddenRoute = computed(() => route.path.startsWith("/customer/timesheets") || route.path.startsWith("/auth"));

  const init = () => {
    // The mascot launcher replaces Gleap's own button.
    Gleap.showFeedbackButton(false);
    Gleap.initialize("Ug8XEAQT0lBqu7IIolKszijTTBdpdiqO");
    Gleap.on("unread-count-changed", (count) => {
      if (typeof count === "number") unreadCount.value = count;
    });
  };

  const identify = (
    id: string,
    user: { name: string; email: string | undefined; customData: Record<string, unknown> }
  ) => {
    const sessionKey = JSON.stringify({ id, user });
    if (sessionKey === lastIdentifiedSessionKey) return;

    lastIdentifiedSessionKey = sessionKey;
    Gleap.identify(id, user);
  };

  const clearIdentity = () => {
    lastIdentifiedSessionKey = null;
    Gleap.clearIdentity();
  };

  const open = () => Gleap.open();

  return { init, identify, clearIdentity, open, isHiddenRoute, unreadCount: readonly(unreadCount) };
};
